import { useState, useEffect, useCallback } from 'react';
import AuditLogService from '../services/auditLogService';
import { AuditLog, AuditLogFilters } from '../models/AuditLog';

export const useAuditLog = (filters: AuditLogFilters) => {
    const [logs, setLogs] = useState<AuditLog[]>([]);
    const [total, setTotal] = useState<number>(0);
    const [totalPages, setTotalPages] = useState<number>(1);
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);

    const fetchLogs = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const result = await AuditLogService.getLogs(filters);
            setLogs(result.data);
            setTotal(result.total);
            setTotalPages(result.totalPages);
        } catch (err) {
            setError('Failed to load audit log.');
            setLogs([]);
        } finally {
            setLoading(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [JSON.stringify(filters)]);

    useEffect(() => {
        fetchLogs();
    }, [fetchLogs]);

    return { logs, total, totalPages, loading, error, refetch: fetchLogs };
};
